import React from "react";
import _ from "lodash";
import numeral from "numeral";
import {
  parseTableData,
  filterDataToGroup,
} from "../IntegrationVerificationHelper";
import GroupDataTable from "./GroupDataTable";
import FilterControl from "./FilterControl";

class GeneralPerformanceView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      columns: [],
      groups: [],
      amount: null,

      filterGroups: [],
      filterRecords: [],
      filterAmount: null,

      tags: [],
      alias: [],
    };

    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    const { records, columns } = this.props;
    const newRecords = [];
    const newColumns = [
      columns[0],
      columns[1],
      ...columns.slice(2, 7).map((d) => `b_${d}`),
      ...columns.slice(2, 7).map((d) => `o_${d}`),
      "total_request",
    ];

    const dateIdx = _.indexOf(columns, "date");
    const idIdx = _.indexOf(columns, "ext_gam_unit_id");
    const groupIdx = _.indexOf(columns, "group_type");
    const reqIdx = _.indexOf(columns, "request");
    const dateList = _.union(_.map(records, (item) => item[dateIdx]));
    const idList = _.union(_.map(records, (item) => item[idIdx]));

    const keyMap = new Map();

    _.forEach(records, (item) => {
      keyMap.set(`${item[dateIdx]}-${item[idIdx]}-${item[groupIdx]}`, item);
    });

    _.forEach(dateList, (date) => {
      _.forEach(idList, (id) => {
        const bItem = keyMap.get(`${date}-${id}-b`);
        const oItem = keyMap.get(`${date}-${id}-o`);

        const breq = bItem ? bItem[reqIdx] : 0;
        const oreq = oItem ? oItem[reqIdx] : 0;
        newRecords.push([
          date,
          id,
          ...(bItem ? bItem.slice(2, 7) : Array(5).fill(0)),
          ...(oItem ? oItem.slice(2, 7) : Array(5).fill(0)),
          breq + oreq,
        ]);
      });
    });

    const arrangeCol = [
      {
        key: "ext_gam_unit_id",
        label: "Ext Gam Unit Id",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        key: "date",
        label: "Date",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        key: "total_request",
        label: "total #",
        groupfunc: (list) => {
          return _.sum(list);
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "b_holistic_rev",
        label: "holistic rev #",
        group: "b",
        hide: true,
        groupfunc: (list) => {
          return _.sum(list);
        },
        format: (val) => {
          return numeral(val).format("$0,0");
        },
      },
      {
        key: "b_google_rev",
        label: "google rev #",
        group: "b",
        hide: true,
        groupfunc: (list) => {
          return _.sum(list);
        },
        format: (val) => {
          return numeral(val).format("$0,0");
        },
      },
      {
        key: "b_request",
        label: "req #",
        group: "b",
        groupfunc: (list) => {
          return _.sum(list);
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "b_holistic_rpm",
        label: "holistic rRPM",
        group: "b",
        parsefunc: ({ b_request, b_holistic_rev }) => {
          return b_request === 0 ? 0 : b_holistic_rev / (b_request * 1000);
        },
        format: (val) => {
          return numeral(val).format("$0.0000");
        },
      },
      {
        key: "b_google_rpm",
        label: "google rRPM",
        group: "b",
        parsefunc: ({ b_request, b_google_rev }) => {
          return b_request === 0 ? 0 : b_google_rev / (b_request * 1000);
        },
        format: (val) => {
          return numeral(val).format("$0.0000");
        },
      },
      {
        key: "o_holistic_rev",
        label: "holistic rev #",
        group: "o",
        hide: true,
        groupfunc: (list) => {
          return _.sum(list);
        },
        format: (val) => {
          return numeral(val).format("$0,0");
        },
      },
      {
        key: "o_google_rev",
        label: "google rev #",
        group: "o",
        hide: true,
        groupfunc: (list) => {
          return _.sum(list);
        },
        format: (val) => {
          return numeral(val).format("$0,0");
        },
      },
      {
        key: "o_request",
        label: "req #",
        group: "o",
        groupfunc: (list) => {
          return _.sum(list);
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "o_holistic_rpm",
        label: "holistic rRPM",
        group: "o",
        parsefunc: ({ o_request, o_holistic_rev }) => {
          return o_request === 0 ? 0 : o_holistic_rev / (o_request * 1000);
        },
        format: (val) => {
          return numeral(val).format("$0.0000");
        },
      },
      {
        key: "o_google_rpm",
        label: "google rRPM",
        group: "o",
        parsefunc: ({ o_request, o_google_rev }) => {
          return o_request === 0 ? 0 : o_google_rev / (o_request * 1000);
        },
        format: (val) => {
          return numeral(val).format("$0.0000");
        },
      },
      {
        key: "holistic_uplift",
        label: "holistic uplift",
        parsefunc: ({ b_holistic_rpm, o_holistic_rpm }) => {
          return b_holistic_rpm === 0
            ? 0
            : (o_holistic_rpm - b_holistic_rpm) / b_holistic_rpm;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
      {
        key: "google_uplift",
        label: "google uplift",
        parsefunc: ({ b_google_rpm, o_google_rpm }) => {
          return b_google_rpm === 0
            ? 0
            : (o_google_rpm - b_google_rpm) / b_google_rpm;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
    ];

    const result = parseTableData({
      columns: newColumns,
      arrangeColumns: arrangeCol,
      records: newRecords,
      mainKey: "ext_gam_unit_id",
      orderKey: "total_request",
    });

    this.setState({
      ...result,
      filterGroups: result.groups,
      filterRecords: result.records,
      filterAmount: result.amount,
      columns: arrangeCol,
      tags: arrangeCol
        .slice(2)
        .filter((item) => !item.hide)
        .map((item) => ({
          value: item.key,
          label: item.label,
          group: item.group,
        })),
      alias: [
        {
          value:
            "total_request >= 10000 AND (holistic_uplift <= -0.05 OR holistic_uplift >= 0.05)",
          label: "Quick Filter",
        },
        {
          func: (inputValue) =>
            `total_request >= 10000 AND (holistic_uplift <= ${(
              inputValue - 0.05
            ).toFixed(2)} OR holistic_uplift >= ${(inputValue + 0.05).toFixed(
              2
            )})`,
          label: "Custom Holistic Uplift",
        },
      ],
    });
  }

  handleSearch(expression) {
    const { records, columns } = this.state;

    const result = filterDataToGroup({
      expression,
      records,
      columns,
    });

    if (result) {
      this.setState({
        ...result,
      });
    }
  }

  render() {
    const { columns, alias, tags, filterAmount, filterGroups, filterRecords } =
      this.state;
    return (
      <>
        <div className="mb-2">
          <FilterControl
            tags={tags}
            alias={alias}
            handleSearch={this.handleSearch}
          ></FilterControl>
        </div>
        <GroupDataTable
          columns={columns}
          records={filterRecords}
          groups={filterGroups}
          amount={filterAmount}
          mainKey="ext_gam_unit_id"
          header={
            <tr className="bg-gray-100">
              <th className="border px-2 py-1 text-center" colSpan={4}></th>
              <th className="border px-2 py-1 text-center" colSpan={3}>
                b
              </th>
              <th className="border px-2 py-1 text-center" colSpan={3}>
                o
              </th>
              <th className="border px-2 py-1 text-center" colSpan={2}></th>
            </tr>
          }
        ></GroupDataTable>
      </>
    );
  }
}
export default GeneralPerformanceView;
